module.exports = __webpack_public_path__ + "img/family-tree-02.e16fbbde.png";